import {get, set, remove} from "./storage"

export default {
    get,
    set,
    remove
}